(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lib-whatsapp-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ==== lib core v2.0.0 (same copy inside every library file; keep in sync with _build/lib-core.js) ====
  window.lib = window.lib || (function () {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var fmt;
    // Money format comes from a sample the theme's own money filter rendered (data-lib-money), so it follows Shopify Markets.
    function format() {
      if (fmt !== undefined) return fmt;
      var el = document.querySelector('[data-lib-money]');
      var sample = el ? el.getAttribute('data-lib-money') : '';
      var m = sample.match(/\d[\d.,'\s]*\d/);
      if (!m) return (fmt = null);
      var num = m[0], tail = num.slice(-3), dec = /^[.,]\d\d$/.test(tail);
      var body = dec ? num.slice(0, -3) : num;
      return (fmt = { before: sample.slice(0, m.index), after: sample.slice(m.index + num.length), dec: dec ? tail.charAt(0) : '', sep: (body.match(/[^\d]/) || [''])[0] });
    }
    function money(cents) {
      cents = Math.round(Number(cents) || 0);
      var f = format();
      if (!f) return (cents / 100).toFixed(2);
      var txt = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, f.sep);
      if (f.dec) txt += f.dec + String(cents % 100).padStart(2, '0');
      return f.before + txt + f.after;
    }
    function fill(text, values) {
      text = String(text || '');
      Object.keys(values).forEach(function (k) { text = text.split('[' + k + ']').join(values[k]); });
      return text;
    }
    function track(name, data) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    }
    function json(res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); }
    function applyCode(code) {
      if (!code) return Promise.resolve();
      return fetch(base + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    }
    var extras = [], propFns = [];
    function lineProperties() {
      var out = null;
      propFns.forEach(function (fn) { try { var p = fn(); if (p) { out = out || {}; Object.keys(p).forEach(function (k) { out[k] = p[k]; }); } } catch (e) {} });
      return out;
    }
    // Adds items in one request. Applies the discount code first, so the price customers saw is the price they pay.
    function add(items, opts) {
      opts = opts || {};
      var all = items.concat(!opts.extras ? [] : extras.reduce(function (a, fn) { try { return a.concat(fn() || []); } catch (e) { return a; } }, []));
      var body = { items: all };
      if (document.querySelector('cart-drawer')) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      return applyCode(opts.code).then(function () {
        return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      }).then(json).then(function (res) {
        document.dispatchEvent(new CustomEvent('lib:cart:added', { detail: { items: all, response: res } }));
        return res;
      });
    }
    function cart() { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(json); }
    function change(line, quantity) {
      return fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) }).then(json);
    }
    // Refreshes the theme's cart drawer and count (Dawn family, Kalles, or any theme listening to cart events).
    function refresh(res) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        var p = res && res.sections ? Promise.resolve(res) : fetch(base + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) { return { sections: s }; });
        return p.then(function (r) { drawer.classList.remove('is-empty'); drawer.renderContents(r); return true; });
      }
      if (window.T4SThemeSP && T4SThemeSP.Cart && T4SThemeSP.Cart.getToFetch) {
        T4SThemeSP.isATCSuccess = true;
        T4SThemeSP.Cart.getToFetch();
        return Promise.resolve(true);
      }
      ['cart:refresh', 'cart:updated', 'cart:update'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
      return Promise.resolve(false);
    }
    function after(res, mode, code) {
      if (mode === 'checkout') { location.href = base + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); return; }
      if (mode === 'cart') { location.href = base + 'cart'; return; }
      if (mode === 'stay') { refresh(res); return; }
      refresh(res).then(function (ok) { if (!ok) location.href = base + 'cart'; });
    }
    function productForm(ids, exclude) {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i], id = f.querySelector('[name="id"]');
        if (exclude && exclude.contains(f)) continue;
        if (id && (!ids || ids.indexOf(Number(id.value)) !== -1)) return f;
      }
      return null;
    }
    function currentVariant(ids, exclude) {
      var f = productForm(ids, exclude), id = f && f.querySelector('[name="id"]');
      return id ? Number(id.value) : null;
    }
    function onVariant(ids, cb) {
      function maybe(id) { id = Number(id); if (id && (!ids || ids.indexOf(id) !== -1)) cb(id); }
      document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') maybe(e.target.value); });
      ['variant:change', 'variant:changed', 'variant:update'].forEach(function (n) {
        document.addEventListener(n, function (e) {
          var d = e.detail || {};
          maybe((d.variant && d.variant.id) || (d.resource && d.resource.id) || (e.currentVariant && e.currentVariant.id));
        });
      });
    }
    // Moves a block next to the theme's add-to-cart buttons. Returns true when it found them.
    function mountNearBuy(el, ids, where, hideNative) {
      var f = productForm(ids, el);
      if (!f) return false;
      var submit = f.querySelector('[type="submit"], [name="add"]');
      var anchor = submit ? (submit.closest('.product-form__buttons, .product-form__submit-wrapper, .t4s-product-form__buttons') || submit) : f;
      anchor.parentNode.insertBefore(el, where === 'after' ? anchor.nextSibling : anchor);
      if (hideNative && anchor !== f) anchor.style.setProperty('display', 'none', 'important');
      return true;
    }
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
      document.addEventListener('shopify:section:load', fn);
    }
    return {
      base: base, money: money, fill: fill, track: track, add: add, cart: cart, change: change, refresh: refresh, after: after,
      applyCode: applyCode, productForm: productForm, currentVariant: currentVariant, onVariant: onVariant, mountNearBuy: mountNearBuy,
      registerExtras: function (fn) { extras.push(fn); }, registerProperties: function (fn) { propFns.push(fn); }, lineProperties: lineProperties, ready: ready
    };
  })();
  // ==== end lib core ====

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var phone = root.dataset.phone;
    var dataEl = root.querySelector('[data-lwa-product]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var ids = product ? product.variants.map(function (v) { return v.id; }) : null;

    // Build the text when clicked, so it always has the size, color and quantity picked last.
    function buildText() {
      if (product && root.dataset.productMsg) {
        var id = lib.currentVariant(ids) || product.variants[0].id;
        var v = product.variants.filter(function (x) { return x.id === id; })[0] || product.variants[0];
        var form = lib.productForm(ids);
        var qtyInput = form && (form.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"]'));
        var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
        return lib.fill(root.dataset.productMsg, { product: product.title, variant: product.single ? '' : v.title, qty: qty, price: lib.money(v.price * qty), url: product.url + '?variant=' + v.id }).replace(/\n{3,}/g, '\n\n').trim();
      }
      var text = root.dataset.message || '';
      if (root.dataset.addPage === 'true') text += '\n' + root.dataset.pageLabel + ' ' + location.origin + location.pathname + location.search;
      return text.trim();
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-gx-wa]');
      if (!link || !(root.contains(link) || link.closest('[data-lwa-inline]'))) return;
      link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildText());
      lib.track('lib_whatsapp_order', { product: !!product });
    }, true);
  }
  lib.ready(function () { document.querySelectorAll('.lwa-root').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();
})();
